import React from 'react'
import Page from "../Page";
import Opportunity from "../../models/Opportunity";
import Modal from "../../components/Modal";
import OppRejectionFeedbackModal from "./components/OppRejectionFeedbackModal";
import OpportunityDetails from "./OpportunityDetails";
import LoadingBanner from "../../components/LoadingBanner";
import OppDashboard from "./OppDashboard";
import JobProfileSummaryModal from "../talent-job-board/components/JobProfileSummaryModal";
import {generatePath, Link, Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {useOpportunity} from "../../providers/OpportunityProvider";
import PageNotAllowed from '../../components/errors/PageNotAllowed';

export default class OppBriefStep extends Page {

    static path = '/review-project-brief';

    static title = 'Brief';

    static badgeForOpp(opportunity) {
        if (!opportunity.isInterested() && !opportunity.isAccepted()) {
            return (
                <i className="fas text-danger fa-exclamation-circle"/>
            )
        }
        return null
    }

    static isLocked(opportunity) {
        return !opportunity.detailedViewAvailable()
    }

    static pathForOppBrief(opp, briefSection) {
        let oppId = opp;
        if (TB.isObject(opp)) {
            oppId = opp.id;
        }

        let path = OpportunityDetails.pathForOpp(oppId, OppBriefStep);

        path = generatePath(path, {project_id: oppId})

        if (briefSection && briefSection.sectionTitle) {
            path += `/${TB.slugify(briefSection.sectionTitle)}`;
        }
        if (opp?.is_agency_opp) {
            path = TB.replace(path, 'talent', 'supplier')
            // path = TB.replace(path, '/review-project-brief', '')
        }

        return path;
    }

    static accomplishedForOpportunity(opportunity) {
        return opportunity.isAccepted()
    }

    constructor(props) {
        super(props);

        this.rejectModal = React.createRef();
        this.routeRef = React.createRef();
        this.state = {
            ...this.state,
            opportunity: Opportunity.make({...props.opportunity}),
            isLoading: true,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.middlewareCheck(async () => {
            await this.markAsViewed();

            return this.promisedState({isLoading: false})
        })
    }

    async markAsViewed() {
        return new Promise(async (resolve) => {
            try {

                let request = TB.request(`/api/talent-user-opportunities/${this.state.opportunity?.id}/track/view-brief`);

                let response = await request.post();
                console.log('markedAsViewed', response)
            } catch (e) {
                console.warn(e)
            }
            resolve()
        });
    }

    validateProjectMiddleware() {
        let opportunity = this.props.opportunity;

        // if (opportunity.isInterested()) {
        //     return {
        //         key: 'talent.opportunity_prompt_needs_invite',
        //         redirect: OppDashboard
        //     };
        // }
    }

    async middlewareCheck(callback = () => {
    }) {
        let error = this.validateProjectMiddleware();

        if (!error) {
            return callback();
        }

        await TB.sysAlert(error.key);

        return this.props.navigate('..' + error.redirect.path, {replace: true});
    }

    hasPrevStep() {
        let activeStepIndex = this.activeStepIndex();

        return activeStepIndex > 0;
    }

    goToPrevStep() {
        let prevStep = this.prevStep();
        if (!prevStep) {
            return;
        }
        this.props.navigate({pathname: OppBriefStep.pathForOppBrief(this.props.opportunity, prevStep)}, {replace: true});

        // this.setState({activeStep: prevStep.sectionTitle})
    }

    prevStep() {
        let activeStepIndex = this.activeStepIndex();
        activeStepIndex--;

        return this.state.opportunity.projectBriefSteps()[activeStepIndex];

    }

    nextStep() {
        let activeStepIndex = this.activeStepIndex();
        activeStepIndex++;

        return this.state.opportunity.projectBriefSteps()[activeStepIndex];
    }

    hasNextStep() {
        let activeStepIndex = this.activeStepIndex();

        return activeStepIndex < (this.state.opportunity.projectBriefSteps().length - 1);
    }

    goToNextStep() {
        let nextStep = this.nextStep();
        if (!nextStep) {
            return;
        }

        this.props.navigate({pathname: OppBriefStep.pathForOppBrief(this.props.opportunity, nextStep)}, {replace: true});
        // this.setState({activeStep: nextStep.sectionTitle})
    }

    async completeStep() {
        let opportunity = {...this.state.opportunity}

        if (this.props.opportunity.isInterested() || this.props.opportunity?.isAccepted()) {
            return this.goToNextStep();
        }

        if (this.state.opportunity.hasAcceptedProjectBriefSections() && !this.hasNextStep()) {
            console.log("hasAcceptedProjectBriefSections NO next step")
            // return this.acceptOpportunity();
        }
        let updateBriefFields = [
            'accepted_at',
            'rejected_at',
            'rejection_reason',
            'rejection_reason_notes',
            'rejected_at',
            'withdrew_at',
            'accepted_for_team_at',
            'rejected_for_team_at',
            'withdrew_for_team_at',
            ...TB.pluck(this.state.opportunity.projectBriefSteps(), 'CompletedField'),
        ]
        let updatedOpp = await this.props.onUpdate(TB.pick(opportunity, updateBriefFields));

        if (updatedOpp) {
            await this.promisedState({opportunity: updatedOpp})


            if (!this.hasNextStep() && !updatedOpp.hasAcceptedProjectBriefSections()) {
                return this.alertForMissingSections();
            }
            if (this.activeStep().isCompleted(updatedOpp)) {
                if (!this.hasNextStep()) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });

                }
                return this.goToNextStep();
            }
        }
    }


    showJobProfileSummaryModal = async () => {
        await TB.event("Modal@hide");
        await TB.wait(600);
        return TB.event("Modal@show", {
            modalClass: "job-match-details-modal",
            content: (
                <JobProfileSummaryModal
                    disabled={this.props.isDisabled}
                    onRequestClose={() => TB.event("Modal@hide")}
                />
            )
        })
    }

    async acceptOpportunity() {
        if (this.state.opportunity.isAccepted()) {
            return;
        }

        if (!this.state.opportunity.hasAcceptedProjectBriefSections()) {
            return this.alertForMissingSections();
        }

        // let opportunity = {...this.state.opportunity}
        // opportunity.accepted_at = new Date();
        // let opportunity = {...this.state.opportunity, accepted_at: new Date()};


        let opportunity = await this.props.onAccept();
        // console.log("ACCEPTED", opportunity)
        if (opportunity) {

            await this.promisedState({opportunity})

            if (!opportunity.hasSubmittedProposal() || opportunity.isProposingWithTeam()) {

                return this.props.navigate({...this.props.location, search: "?proposal=1&returnToProposal=1"}, {replace: true})
                // return TB.event("Modal@show", {
                //     modalClass: "job-proposal-modal",
                //     onCloseAction: () => {
                //         return this.props.navigate({
                //             pathname: OpportunityDetails.pathForOpp(opportunity, opportunity.currentProjectStep())
                //         })
                //     },
                //     canExit: false,
                //     content: (
                //         <OppProposalWalkthrough
                //             key={TB.uuid() + opportunity.id}
                //             opportunity={opportunity}
                //             disabled={this.props.isDisabled}
                //             showSteps={true}
                //             onRequest={this.props.onRequest}
                //             onComplete={async () => {
                //                 if (this.context?.auth?.shouldRemindForPreferencesResumeUpdate()) {
                //                     await TB.event("Modal@hide");
                //                     await TB.wait(600);
                //                     return TB.event("Modal@show", {
                //                         modalClass: "preferences-update-reminder-modal",
                //                         defaultScroll: false,
                //                         content: (
                //                             <JobProfileResumeModal
                //                                 disabled={this.props.isDisabled}
                //                                 onRequestClose={() => this.showJobProfileSummaryModal()}
                //                             />
                //                         )
                //                     })
                //                 }
                //                 return this.showJobProfileSummaryModal()
                //             }}
                //         />
                //     )
                // })
            }


            // Send to next step
            if (opportunity.currentProjectStep() !== OppBriefStep) {

                return this.props.navigate({
                    pathname: OpportunityDetails.pathForOpp(opportunity, opportunity.currentProjectStep())
                })
            }
        }
    }

    async rejectOpportunity() {
        await this.rejectModal.current.showModal();
    }

    async withdrawFromOpportunity() {
        let didWithdraw = await this.props.onWithdraw()
        console.log('withdrawFromOpportunity', didWithdraw)
        if (!didWithdraw) {
            return;
        }
    }
    async removeInterestForOpportunity() {
        let didRemoveInterest = await this.props.onRemoveInterest()
        console.log('withdrawFromOpportunity', didRemoveInterest)
        if (!didRemoveInterest) {
            return;
        }
    }

    alertForMissingSections() {
        return TB.sysAlert('talent.accept_opportunity_brief_required');
    }

    activeStep() {
        if (!this.state.opportunity) {
            return;
        }

        return TB.find(this.state.opportunity.projectBriefSteps(), step =>
            TB.includes(this.props.location.pathname, TB.slugify(step.sectionTitle))
        );
    }

    activeStepIndex() {
        let activeStep = this.activeStep();
        if (!activeStep) {
            return;
        }

        return this.state.opportunity.projectBriefSteps().indexOf(activeStep);
    }

    render() {
        if (this.context.auth?.isTalentSupplierResource()) {
            return <PageNotAllowed redirect="/talent/dashboard" />
        }

        if (!this.state.opportunity) {
            return <div/>;
        }

        // let error = this.validateProjectMiddleware();

        // if (error) {
        // let title = TB.tryTrans('start_project.contract.errors.' + error + '.title'),
        // 	message = TB.tryTrans('start_project.contract.errors.' + error + '.message');

        // return <div/>
        // }

        let ActiveStep = this.activeStep(),
            sowSteps = this.state.opportunity.projectBriefSteps();

        let {
            isLoading
        } = this.state;

        return (
            <div className="talent-portal-container">
                {isLoading ? (
                    <LoadingBanner message="Loading Contract"/>
                ) : (
                    <React.Fragment>
                        <div className="talent-portal-page-container talent-opportunity-container px-3">

                            <div className="talent-opp-wizard-header talent-opportunity-brief-btns pt-6">

                                <h2>Project Brief</h2>

                                {this.props.opportunity.hasUnseenUpdate() && (
                                    <p className="opp-unseen-info">
                                        <i className="fas fa-exclamation-circle mr-2"/>
                                        Updated since last viewed
                                    </p>
                                )}

                                {(this.props.opportunity.can_be_accepted || this.props.opportunity.can_be_rejected) && (
                                    <div className="flex flex-row items-center ml-auto">
                                        <p>This Opportunity</p>

                                        <button className="btn btn-primary"
                                                disabled={!this.state.opportunity.can_be_accepted || this.props.isDisabled}
                                                onClick={this.acceptOpportunity.bind(this)}>
                                            Pursue
                                        </button>

                                        {this.props.opportunity.can_be_rejected && (
                                            <p>Or</p>
                                        )}
                                        {this.props.opportunity.can_be_rejected && (
                                            <button className="btn btn-dark"
                                                    disabled={!this.props.opportunity.can_be_rejected || this.props.isDisabled}
                                                    onClick={this.rejectOpportunity.bind(this)}>
                                                Pass
                                            </button>
                                        )}
                                    </div>
                                )}

                                <div className="flex flex-row items-center ml-auto">
                                    <p>This Opportunity</p>
                                    <button className="btn btn-dark"
                                            disabled={this.props.isDisabled || (this.props.opportunity.isInterested() ?
                                                !this.props.opportunity.project_position?.has_shown_interest_in_job :
                                                !this.props.opportunity.can_be_withdrawn)
                                    }
                                            onClick={this.props.opportunity.isInterested() ?
                                                this.removeInterestForOpportunity.bind(this) :
                                                this.withdrawFromOpportunity.bind(this)
                                    }>
                                        Withdraw Interest
                                    </button>
                                </div>
                            </div>

                            <div className="md:flex flex-row justify-center mb-5">

                                <div className='w-full md:w-3/12 brief-steps-menu text-center'
                                     style={{maxHeight: sowSteps.length * 54}}>

                                    {sowSteps.map((step, i) => {
                                        let sectionTitle = this.state.opportunity.briefTab(step);

                                        let isActive = this.props.location.pathname === OppBriefStep.pathForOppBrief(this.props.opportunity, step),
                                            isComplete = step.isCompleted(this.props.opportunity),
                                            hasUpdates = this.state.opportunity.projectBriefHasUnseenUpdatesAtStep(
                                                step
                                            );

                                        let icon = 'dot-circle';
                                        if (isComplete) {
                                            icon = 'check';
                                        } else if (isActive) {
                                            icon = 'circle';
                                        }

                                        return (
                                            <button key={`sowStep${i}`}
                                                    className={TB.mapClass('btn brief-step-btn', {
                                                        'active': isActive,
                                                        'no-click': isActive || this.props.isDisabled
                                                    })}
                                                    onClick={e => {
                                                        if (isActive || this.props.isDisabled) {
                                                            e.preventDefault()
                                                        } else {
                                                            this.props.navigate({pathname: OppBriefStep.pathForOppBrief(this.props.opportunity, step)})
                                                        }
                                                    }}>
                                                {!this.props.opportunity.isInterested() && <i className={`fa fa-${icon} mr-3`}/>}
                                                {sectionTitle}
                                                {hasUpdates &&
                                                    <i className="fas fa-exclamation-circle opp-unseen-icon ml-3"/>}
                                            </button>
                                        );
                                    })}
                                </div>

                                <div className='md:w-9/12 w-full brief-step-section'>

                                    <h4 className="panel-header">
                                        {this.state.opportunity.project.name}
                                    </h4>
                                    {this.state.opportunity.isService() && this.state.opportunity.project?.service?.name && (
                                        <p className="panel-subheader">
                                            Project Type: {this.state.opportunity.project.service.name}
                                        </p>
                                    )}

                                    {ActiveStep && (
                                        <h3 className="brief-section-title">
                                            {this.state.opportunity.briefHeader(ActiveStep)}
                                        </h3>
                                    )}
                                    {ActiveStep && (
                                        <p className="brief-section-subtitle">
                                            {this.state.opportunity.briefDescription(ActiveStep) || ''}
                                        </p>
                                    )}

                                    <Routes>
                                        <Route index element={<Navigate
                                            to={TB.slugify(this.props.opportunity.currentBriefStepNeeded()?.sectionTitle)}
                                            replace/>}/>

                                        {TB.map(this.state.opportunity.projectBriefSteps(), Step => (
                                            <Route key={Step.sectionTitle} path={TB.slugify(Step.sectionTitle)}
                                                   element={<Step opportunity={this.state.opportunity}/>}/>
                                        ))}
                                        <Route path={'*'} element={<Navigate
                                            to={TB.slugify(this.props.opportunity.currentBriefStepNeeded()?.sectionTitle)}
                                            replace/>}/>

                                    </Routes>

                                    {ActiveStep && (
                                        <div className="flex items-stretch flex-col">
                                            {!this.props.opportunity.isInterested() && !this.props.opportunity.isAccepted() && (
                                                <div className="form-checkbox mt-3 mb-2">

                                                    <input type="checkbox"
                                                           disabled={this.props.isDisabled}
                                                           className="form-check-input"
                                                           id={`${ActiveStep.CompletedField}-checkbox`}
                                                           name={`${ActiveStep.CompletedField}-checkbox`}
                                                           onChange={event => {
                                                               if (!this.props.opportunity.hasAcceptedProjectBriefSections()) {
                                                                   this.setState({
                                                                       opportunity: Opportunity.make({
                                                                               ...this.state.opportunity,
                                                                               [ActiveStep.CompletedField]: event.target.checked ? (new Date()) : null
                                                                           }
                                                                       )
                                                                   })
                                                               }
                                                           }}
                                                           checked={ActiveStep.isCompleted(this.state.opportunity) || false}/>

                                                    <label className="form-check-label"
                                                           htmlFor={`${ActiveStep.CompletedField}-checkbox`}>
                                                        OK, I acknowledge that I have read this page of the brief
                                                    </label>


                                                </div>
                                            )}
                                            <div className="brief-section-btns">
                                                {(this.props.opportunity.isAccepted() || this.props.opportunity.isInterested()) && this.hasPrevStep() && (
                                                    <button
                                                        className="btn btn-primary flex items-center justify-center mr-2"
                                                        disabled={this.props.isDisabled}
                                                        onClick={this.goToPrevStep.bind(this)}>
                                                        <i className="fa fa-chevron-left mr-2"/>
                                                        <span>Prev</span>
                                                    </button>
                                                )}
                                                {(this.hasNextStep() || !ActiveStep.isCompleted(this.props.opportunity)) && (
                                                    <button
                                                        className="btn btn-primary flex items-center justify-center mr-2"
                                                        disabled={this.props.isDisabled || (
                                                            (!this.props.opportunity.isInterested() && !this.props.opportunity.isAccepted()) &&
                                                            !ActiveStep.isCompleted(this.state.opportunity)
                                                        )}
                                                        onClick={this.completeStep.bind(this)}>

                                                        {this.hasNextStep() ? (
                                                            <React.Fragment>
                                                                <span>
                                                                    Next
                                                                </span>

                                                                <i className="fa fa-chevron-right ml-2"/>
                                                            </React.Fragment>
                                                        ) : (
                                                            <span>Save</span>
                                                        )}
                                                    </button>
                                                )}

                                                {(this.props.opportunity.isInterested() || this.props.opportunity.isAccepted()) && !this.hasNextStep() && (
                                                    <Link className="btn btn-dark flex items-center justify-center mr-2"
                                                          disabled={this.props.isDisabled}
                                                          to={OpportunityDetails.pathForOpp(this.props.opportunity, OppDashboard)}>
                                                        Go To Proposal
                                                    </Link>
                                                )}

                                            </div>
                                            {this.props.opportunity.hasAcceptedProjectBriefSections() && !this.hasNextStep() && !this.props.opportunity.isInterested() && !this.props.opportunity.isAccepted() && (
                                                <p style={{fontWeight: 500}} className="text-left">Next Step: Select
                                                    Pursue or Pass button above for this opportunity.</p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <Modal
                            ref={this.rejectModal}
                            modalClass={"opp-reject-feedback-modal"}
                            title="Sorry this project wasn't a fit for you."
                            onCloseAction={async () => {
                                console.log('onClose Action')
                            }}>

                            <OppRejectionFeedbackModal
                                onCancel={() => this.rejectModal.current.hideModal(true)}
                                disabled={this.props.isDisabled}
                                onSubmit={async (model) => {
                                    console.log('onsubmit', model);
                                    await this.rejectModal.current.hideModal(true);

                                    let opportunity = await this.props.onReject();
                                    console.log('REJECTED!', opportunity);
                                    return this.promisedState({opportunity})
                                }}
                            />
                        </Modal>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

const OppBriefTab = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        onRequest,
        onUpdate,
        onAccept,
        onReject,
        onWithdraw,
        onRemoveInterest,
        opportunity,
        isDisabled,
    } = useOpportunity()


    return (
        <OppBriefStep
            location={location}
            navigate={navigate}
            onRequest={onRequest}
            onUpdate={onUpdate}
            onAccept={onAccept}
            onReject={onReject}
            onRemoveInterest={onRemoveInterest}
            onWithdraw={onWithdraw}
            opportunity={opportunity}
            isDisabled={isDisabled}/>
    )
}

export {
    OppBriefTab
}